import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse>;

const deleteSectionAsset = (formId: string, sectionId: string): ReturnType => {
    return Request.delete(`/data/forms/${formId}/sections/${sectionId}/asset`);
};

export default deleteSectionAsset;
